<script lang="ts">
	import { Device, DeviceRPi } from "luxedo-data"
	import { openOverlay } from "overlay"
	import MassUpdateInputIndividual from "./MassUpdate_InputIndividual.svelte"
	import { RefreshIcon } from "luxedo-icons"
	import { Toast } from "toaster"
	import { MassUpdater } from "./MassUpdateController"
	import { LuxedoRPC } from "luxedo-rpc"

	interface Props {
		devices: Array<DeviceRPi>
		version: string
	}

	let { devices, version }: Props = $props()

	function openInput() {
		openOverlay(MassUpdateInputIndividual, {
			classOverlay: "no-pad",
		})
	}

	async function forceRefresh(device: Device) {
		Toast.text(`Attempting to reconnect to ${device.id}...`)
		await MassUpdater.forceRefreshDevice(device.id)
		Toast.text(`Reconnect trigger sent to ${device.id}.`)
	}

	async function fixStuckUpdate(id: number) {
		try {
			Toast.text(`Attempting to fix ${id}`)
			const data = await LuxedoRPC.api.admin.admin_fix_stuck_update(id)
			console.log("Return from fix stuck update", data)
			if (data.fixed) Toast.success(`Device ${id} should be updating now...`)
			else Toast.error(`Failed to update device ${id}. Info: ${data.info}`)
		} catch (e) {
			console.error(e)
			Toast.error("Failed to update device...")
		}
	}
</script>

<table>
	<thead>
		<tr>
			<th>ID</th>
			<th>Version</th>
			<th>Updated?</th>
			<th>Status</th>
			<th></th>
		</tr>
	</thead>
	<tbody>
		{#each devices as device (device.id)}
			<tr>
				<td>{device.id}</td>
				<td>{device.firmwareVersion}</td>
				<td style="color: {device.compareVersion(version) >= 0 ? 'green' : 'red'};"
					>{device.compareVersion(version) >= 0 ? "✔" : "✘"}</td
				>
				<td>
					<span>
						<div
							class="status-indicator"
							style="background-color: {device.getStatus().color};"
						></div>
						{device.getStatus().text}
					</span>
				</td>
				<td>
					<div class="flex-row">
						{#if device.compareVersion("2.12.3") < 1}
							<button
								class="small"
								id="fix-stuck-update-button"
								onclick={() => fixStuckUpdate(device.id)}
							>
								Fix 2.12.3
							</button>
						{/if}
						<button
							class="icon-only small"
							onclick={() => forceRefresh(device as unknown as Device)}
						>
							<RefreshIcon />
						</button>
					</div>
				</td>
			</tr>
		{/each}
	</tbody>
</table>
<br />
<button onclick={openInput}>Add device</button>

<style>
	.status-indicator {
		height: 0.75rem;
		width: 0.75rem;
		border-radius: var(--br);
	}

	thead {
		position: sticky;
		top: 0;
		background-color: var(--color-bg-light);
	}

	span {
		display: flex;
		align-items: center;
		gap: 0.5rem;
	}

	td:has(:global(button.icon-only)) {
		width: 0.1%;
		vertical-align: middle;
		white-space: nowrap;
		padding: 0.2rem;
	}

	button.icon-only {
		padding: 0.25rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	button.icon-only :global(svg) {
		height: 1rem;
		width: 1rem;
	}

	#fix-stuck-update-button {
		margin-right: 0.2rem;
	}
</style>
